<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-form ref="queryForm">
            <v-row align="center" justify="center">
                <v-col cols="2" xs="4">
                    <v-text-field
                            clearable prepend-inner-icon="search"
                            v-model="queryRequest.description"
                            label="出库去向"/>
                </v-col>
                <v-col cols="3" xs="4">
                    <v-btn color="primary" :loading="loading" @click="handleQuery">
                        搜索
                        <v-icon right>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn
                            color="primary"
                            class="ma-2"
                            @click="resetQuery">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn color="primary"
                           @click="addParams">添加
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>

        <v-row class="d-flex justify-center">
            <v-col :sm="10" :xs="12" cols="8">
                <v-data-table
                        :headers="headers"
                        :items="list"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        :footer-props="footerOptions"
                        :search="search">
                    <template v-slot:item.actions="{ item }">
                        <v-btn v-if="!item.hospFlag" small color="primary" @click="handleUpdate(item)">修改
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <!--新增弹框 start-->
        <v-dialog v-model="dialog.addWms" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">添加出库去向参数</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-form v-model="addWmsFormValid" ref="addWmsForm">
                                    <v-text-field label="参数值" clearable v-model="addRequest.description"
                                                  :rules="[v => !!v || '参数值必填']" required>
                                    </v-text-field>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn color="primary" text @click="dialog.addWms=false">
                        取消
                    </v-btn>
                    <v-btn color="primary" :disabled="!addWmsFormValid" @click="handleAdd" :loading="addLoading">
                        提交
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--新增弹框 end-->

        <v-dialog v-model="dialog.updWms" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">修改物料来源参数</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-form v-model="updWmsFormValid" ref="addWmsForm">
                                    <v-text-field label="参数值" clearable v-model="updRequest.description"
                                                  :rules="[v => !!v || '参数值必填']" required>
                                    </v-text-field>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn color="primary" text @click="dialog.updWms=false">
                        取消
                    </v-btn>
                    <v-btn color="primary" :disabled="!updWmsFormValid" @click="updateCommit" :loading="updLoading">
                        提交
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

<!--        <v-dialog-->
<!--                v-model="dialog.delWms"-->
<!--                width="500"-->
<!--        >-->
<!--            <v-card>-->
<!--                <v-card-title>-->
<!--                    <span>请确认是否删除出库去向参数：{{delRequest.description}}</span>-->
<!--                </v-card-title>-->
<!--                <v-card-actions>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-btn color="primary" text @click="dialog.delWms = false">取消</v-btn>-->
<!--                    <v-btn color="error" text @click="deleteCommit">-->
<!--                        删除-->
<!--                    </v-btn>-->
<!--                </v-card-actions>-->
<!--            </v-card>-->
<!--        </v-dialog>-->
    </div>
</template>

<script>
    import {addCompanyDic, updateCompanyDic, queryCompanyDic} from "@/api/MaterialSourceParams";

    export default {
        name: "MaterialSourceParams",
        data() {
            return {
                footerOptions:{
                    itemsPerPageOptions:[10,50,100,200]
                },
                loading: false,
                dialog: {
                    addWms: false,
                    delWms: false,
                    updWms: false,
                },
                addLoading: false,
                updLoading: false,
                addWmsFormValid: false,
                updWmsFormValid: false,
                total: 0,
                list: [],
                headers: [
                    {text: '序号', value: 'val', sortable: false, align: 'center',},
                    {text: '参数值', value: 'description', sortable: false, align: 'center',},
                    {text: '操作', value: 'actions', sortable: false, align: 'center',},
                ],
                search: '',
                options: {},
                //查询
                queryRequest: {
                    type: "02",
                    description: "",
                    pagedQueryInfo: {
                        index: 1,
                        pageSize: 10
                    }
                },
                //新增
                addRequest: {
                    type: "02",
                    description: ""
                },
                //修改
                updRequest: {
                    id: "",
                    description: ""
                }
            }
        },
        watch: {
            options: {
                handler(val) {
                    console.log(val)
                    if (val.itemsPerPage == -1) {
                        this.queryRequest.pagedQueryInfo.index = 1
                        this.queryRequest.pagedQueryInfo.pageSize = 999999
                    } else {
                        this.queryRequest.pagedQueryInfo.index = val.page
                        this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
                    }
                    this.handleQuery()
                }
            }
        },
        computed: {},
        methods: {
            //查询
            handleQuery() {
                this.loading = true;
                queryCompanyDic(this.queryRequest).then(res => {
                    this.list = res.list;
                    this.total = res.total;
                    this.loading = false
                }).catch(err => {
                    this.loading = false
                })
            },
            //重置
            resetQuery() {
                this.$refs.queryForm.reset();
                this.handleQuery();
            },
            //新增
            //窗口打开
            addParams() {
                this.dialog.addWms = true;
            },
            //新增提交
            handleAdd() {
                if (this.addWmsFormValid) {
                    this.addLoading = true;
                    addCompanyDic(this.addRequest).then(res => {
                        this.dialog.addWms = false;
                        this.addLoading = false;
                        this.addRequest.description = '';
                        this.handleQuery();
                        this.$refs.notify.show("出库去向参数添加成功", {timeout: 1000, color: 'success'});
                    }).catch(err => {

                    })
                }
            },
            //修改
            handleUpdate(item) {
                this.updRequest = item
                this.dialog.updWms = true
            },
            updateCommit() {
                this.updLoading = true;
                updateCompanyDic(this.updRequest).then(res => {
                    this.dialog.updWms = false;
                    this.updLoading = false;
                    this.handleQuery();
                    this.$refs.notify.show("出库去向参数修改成功", {timeout: 1000, color: 'success'});
                }).catch(err => {

                })
            }

        },
        created() {
        },
        mounted() {
        },
    }
</script>

<style scoped>

</style>
